import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {IFunctionResolver} from '@mintdata-wsp/common/controllers/spreadsheet/formula/operations/eval/FunctionResolver';
import {
    ClientFunction,
    FunctionName,
    FunctionNamespace
} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/ClientFunction';
import bind from 'bind-decorator';

export class FunctionResolverImpl implements IFunctionResolver
{
    @bind
    public findFunctionByName(namespace:FunctionNamespace, funcName:FunctionName):ClientFunction | null
    {
        return commonControllers.spreadsheets.clientFunctions.findFunctionByName(namespace, funcName);
    }

    private static _SINGLETON:IFunctionResolver = new FunctionResolverImpl();

    public static getInstance():IFunctionResolver
    {
        return FunctionResolverImpl._SINGLETON;
    }
}
